import { axiosInstance as request } from '@api/rest.service'

const api = id => `/subscription-periods/${id}/implementation`

/**
 * @description GET /subscription-periods/${id}/implementation
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_PERIOD_IMPLEMENTATION = id => request.get(api(id))

/**
 * @description POST /subscription-periods/${id}/implementation
 * @returns {AxiosPromise<any>}
 */
export const CREATE_SUBSCRIPTION_PERIOD_IMPLEMENTATION = (id, payload) => request.post(api(id), payload)

/**
 * @description PUT /subscription-periods/${id}/implementation
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_SUBSCRIPTION_PERIOD_IMPLEMENTATION = (id, payload) => request.put(api(id), payload)
